import React, { ReactElement } from 'react';
export const Banner = (): ReactElement => {
    return (
        <div className="bg-warning-light p-4 text-center text-16 font-medium">
            This Project is <strong>Closed</strong>. You can re-open the Project if you need to work on it again.
        </div>
    );
};
